import { IContentSource } from "../../../domain/drawing";
import { AbstractSource } from "../../drawing";

export class DebugDocumentSource extends AbstractSource {
  constructor(getToken: () => string, public patientNo: string, public documentId: number, public edition: number, private readonly _kind: string) {
    super(getToken);
  }

  protected getSource(): string {
    const url = "/api/document/" + this.documentId + "/debug-create-pdf-" + this._kind + "?token=" + this.token + "&patientNo=" + this.patientNo + "&edition=" + this.edition;
    console.debug("[Source] " + url);
    return url;
  }

  public clone(): IContentSource {
    return new DebugDocumentSource(
      this._getToken,
      this.patientNo,
      this.documentId,
      this.edition,
      this._kind
    );
  }
}
